import React from "react"
import styled from "styled-components"
import { IconButton } from '@material-ui/core';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import FacebookIcon from '@material-ui/icons/Facebook';

const Contact = () => {
  return (
    <ContactWrapper>
      <H4><span>Find me on:</span></H4>
      <IconsWrapper>
        <IconButton><a href="https://www.facebook.com/tajson.bajceps"><FacebookIcon/></a></IconButton>
        <IconButton><a href="https://github.com/dominikwozniak"><GitHubIcon/></a></IconButton>
        <IconButton><a href="https://www.linkedin.com/in/dominik-wozniak-59a7401a4/"><LinkedInIcon/></a></IconButton>
      </IconsWrapper>
    </ContactWrapper>
  )
}

const ContactWrapper = styled.footer`
  max-width: 500px;
`

const H4 = styled.h4`
  font-weight: ${({theme}) => theme.font.semiBold};
  font-size: 26px;
  color: ${({theme}) => theme.color.black};
  position: relative;
  margin-bottom: 4px;
  
  span::before {
    position: absolute;
    bottom: 0;
    left: -5px;
    display: block;
    content: '';
    width: 102px;
    height: 12px;
    background-color: ${({theme}) => theme.color.blue};
    z-index: -1;
  }
  
  ${({theme}) => theme.media.phone} {
    font-size: 24px;
    
    span::before {
    width: 94px;
    height: 10px;
    }
  }
`

const IconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  
  svg {
    color: ${({theme}) => theme.color.black};
  }
`

export default Contact
